import React, { useState } from 'react';
import axios from 'axios';

import carbonis from "../carbonis.png";
import { UilEnvelopeShield } from '@iconscout/react-unicons';
import { UilCreateDashboard } from '@iconscout/react-unicons';
import { UilRefresh } from '@iconscout/react-unicons';

//Set base URL
const baseUrl = "https://plum-defiant-lamb.cyclic.app/user";


export default function GetAllUsers() {

    const [data, setData] = useState({ data: [] });
    const [isLoading, setIsLoading] = useState(false);
    const [err, setErr] = useState('');

    // useEffect(() => {
    //     // getUser();
    // }, [])

    const handleClick = async () => {
        setIsLoading(true);

        try {
            const response = await axios.get(`${baseUrl}/getallusers`);
            const result = await response;
            // console.log('User data : ', result);
            setData(result);
        } catch (error) {
            setErr(error.message);
            throw new Error(`Error! status: ${error}`);
        } finally {
            setIsLoading(false);
        }
    }

    // if (!!wallet_address) getUser();

    return (
        <div style={{ wordWrap: 'break-word' }}>
            <div className="is-center">
                <img src={carbonis} style={{ width: '200px', marginBottom: "50px", marginTop: "50px" }}></img>
            </div>
            <div className="is-center">
                <button onClick={handleClick} className="button is-black" > <UilRefresh /> &nbsp;&nbsp;
                    Refresh List
                </button>
                <h2>Total registered users : {data.data ? data.data.length : ''} users</h2>
            </div>

            <div className="columns section">
                <div className="column">
                    {err && <h2>{err}</h2>}
                    {isLoading && <h2>Loading...</h2>}

                    <table>
                        <thead>
                            <tr>
                                <th>
                                    Name
                            </th>
                                <th>
                                    Email
                            </th>
                                <th>
                                    Wallet Address
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.data.map(user => {
                                return (
                                    <tr key={user.address}>
                                        <td>
                                            <h2>{user.name}</h2>
                                        </td>
                                        <td>
                                            <h2>{user.email}</h2>
                                        </td>
                                        <td>
                                            <h2>{user.address.slice(0, 4)}...{user.address.slice(-5)}</h2>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
